export default "__VITE_ASSET__ChxqKUTI__"